import { render, staticRenderFns } from "./NoticePage.vue?vue&type=template&id=1cbe0c5a&scoped=true&"
import script from "./NoticePage.vue?vue&type=script&lang=js&"
export * from "./NoticePage.vue?vue&type=script&lang=js&"
import style0 from "./NoticePage.vue?vue&type=style&index=0&id=1cbe0c5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbe0c5a",
  null
  
)

export default component.exports